import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ExpeditionTeamDisclaimer extends Vue {
    @Prop() readonly message: string;
}
